import { agent } from '@shared/services/agent';


export async function performHolidayRollOverOnUser(year: number, userId: string): Promise<any> {
  return await agent.requests.post('/api/v2/roll-over/single', {holidayYear: year, userId: userId})
}

export async function getHolidayCarryOverPreviewForUser(userId: string, year: number): Promise<UsersRollOverHolidayPreview> {
  return await agent.requests.get(`/api/v2/roll-over/${userId}?year=${year}`)
}

export interface UsersRollOverHolidayPreview {
  year: number;
  userId: string;
  name: String;
  unusedAllowanceFromPreviousYear: number;
  daysToCarryOverFromPreviousYear: number;
  thisYearsAllowance: number;
  thisYearsAdditionalDays: number;
  thisYearsCarryOver: number;
  totalDays: number;
}
